/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Link as LinkZDS, LinkProps } from '@zapier/design-system';

import {
  CallToActionEvent,
  EventName,
} from '../../observability/tracking/events';
import { CTAType, useAvroTracking, useTrackEvent } from '../../observability';

interface Props extends LinkProps {
  ctaGoal: CallToActionEvent['cta_goal'];
  ctaName: CallToActionEvent['cta_name'];
  ctaText: string;
}

export const Link = ({
  href,
  ctaText,
  ctaGoal,
  ctaName,
  children,
  ...restProps
}: Props) => {
  const trackEvent = useTrackEvent();
  const { emitCTAClickEvent } = useAvroTracking();

  const handleClick = () => {
    emitCTAClickEvent({
      type: CTAType.cta_link,
      text: ctaText,
      section: 'Block',
      href: href!,
    });
    trackEvent(EventName.CALL_TO_ACTION, {
      path: window.location.pathname,
      from_path: document.referrer,
      cta_name: ctaName,
      cta_raw_text: ctaText,
      cta_goal: ctaGoal,
      link_destination: href,
    });
  };

  return (
    <LinkZDS {...restProps} href={href} onClick={handleClick}>
      {children}
    </LinkZDS>
  );
};
